// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface TypeOfProgramDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
	code: string | null;
	apsGeneralEducation: boolean;
	display: string | null;
}

const TypeOfProgramDTO = {
    className: 'TypeOfProgramDTO',
    create: (initValues?: Partial<TypeOfProgramDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
			code: "",
			apsGeneralEducation: false,
			display: "",
        },
        initValues);
    },
	id: 'id',
	name: 'name',
	code: 'code',
	apsGeneralEducation: 'apsGeneralEducation',
	display: 'display',
};

export default TypeOfProgramDTO;